/**
 * The `?review=` URL param contract, shared by the customer-route `ReviewPermalink`
 * (the consumer that opens the dialogs) and the staff Manifest Review queue (the
 * producer of the link, via `manifestReviewHref`). Kept in this dependency-free
 * module so the staff side can import the contract without pulling in the dialog
 * component graph (Apollo, MUI, generated GraphQL).
 */

/** The `?review=` URL param key this permalink reads/writes. */
export const REVIEW_PARAM_KEY = "review";

export type ReviewParam = "document" | "discrepancies";

/** Parse the `?review=` value; anything unrecognized is treated as absent. */
export function parseReviewParam(raw: string | null): ReviewParam | null {
  return raw === "document" || raw === "discrepancies" ? raw : null;
}
